export const termRefBlankSlate = (
  <svg width="100%" viewBox="0 0 602 846" style={{ paddingTop: "44px" }}>
    <g id="Group_2653" data-name="Group 2653" transform="translate(-4511 -39)">
      <text
        id="Users"
        transform="translate(4540 394)"
        fill="#428bca"
        fontSize="14"
        fontFamily="OpenSansSemibold, OpenSans"
        fontWeight="600"
      >
        <tspan x="0" y="0">
          Users
        </tspan>
      </text>
      <text
        id="Business_SME:"
        data-name="Business SME:"
        transform="translate(4540 428)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Business SME:
        </tspan>
      </text>
      <text
        id="Data_Steward:"
        data-name="Data Steward:"
        transform="translate(4540 460)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Data Steward:
        </tspan>
      </text>
      <line
        id="Line_196"
        data-name="Line 196"
        x2="602"
        transform="translate(4511 123)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <line
        id="Line_197"
        data-name="Line 197"
        x2="602"
        transform="translate(4511 500)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <line
        id="Line_359"
        data-name="Line 359"
        x2="602"
        transform="translate(4511 718)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <line
        id="Line_201"
        data-name="Line 201"
        x2="602"
        transform="translate(4511 349)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <g id="Group_921" data-name="Group 921" transform="translate(2962 -151)">
        <text
          id="Trail"
          transform="translate(1577 696)"
          fill="#428bca"
          fontSize="14"
          fontFamily="OpenSansSemibold, OpenSans"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Trail
          </tspan>
        </text>
      </g>
      <text
        id="Also_known_as:"
        data-name="Also known as:"
        transform="translate(4540 171)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Also known as:
        </tspan>
      </text>
      <text
        id="Definition:"
        transform="translate(4540 211)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Definition:
        </tspan>
      </text>
      <text
        id="Example:"
        transform="translate(4540 273)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Example:
        </tspan>
      </text>
      <text
        id="Category:"
        transform="translate(4540 309)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Sub-domain:
        </tspan>
      </text>
      <g id="Group_1167" data-name="Group 1167" transform="translate(2962 54)">
        <text
          id="Classification"
          transform="translate(1577 696)"
          fill="#428bca"
          fontSize="14"
          fontFamily="OpenSansSemibold, OpenSans"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Attributes
          </tspan>
        </text>
      </g>
      <g
        id="Group_1168"
        data-name="Group 1168"
        transform="translate(3212 -112)"
      >
        <text
          id="Term_Type:"
          data-name="Term Type:"
          transform="translate(1328 896)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Term Type:
          </tspan>
        </text>
        <g id="Group_1808" data-name="Group 1808">
          <text
            id="Categorical:"
            transform="translate(1328 928)"
            fill="#4c4c4c"
            fontSize="14"
            fontFamily="OpenSans, OpenSans"
            letterSpacing="-0.005em"
          >
            <tspan x="0" y="0">
              Categorical:
            </tspan>
          </text>
          <text
            id="Privacy_Classification:"
            data-name="Privacy Classification:"
            transform="translate(1328 960)"
            fill="#4c4c4c"
            fontSize="14"
            fontFamily="OpenSans, OpenSans"
            letterSpacing="-0.005em"
          >
            <tspan x="0" y="0">
              Privacy Classification:
            </tspan>
          </text>
          <text
            id="Sensitivity_Classification:"
            data-name="Sensitivity Classification:"
            transform="translate(1328 992)"
            fill="#4c4c4c"
            fontSize="14"
            fontFamily="OpenSans, OpenSans"
            letterSpacing="-0.005em"
          >
            <tspan x="0" y="0">
              Sensitivity Classification:
            </tspan>
          </text>
        </g>
      </g>
      <g
        id="Group_1807"
        data-name="Group 1807"
        transform="translate(3211 -317)"
      >
        <text
          id="Created_on:"
          data-name="Created on:"
          transform="translate(1328 896)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Created on:
          </tspan>
        </text>
        <text
          id="Updated_on:"
          data-name="Updated on:"
          transform="translate(1328 960)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Updated on:
          </tspan>
        </text>
        <text
          id="Created_by:"
          data-name="Created by:"
          transform="translate(1328 928)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Created by:
          </tspan>
        </text>
        <text
          id="Updated_by:"
          data-name="Updated by:"
          transform="translate(1328 992)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Updated by:
          </tspan>
        </text>
      </g>
      <rect
        id="Rectangle_1485"
        data-name="Rectangle 1485"
        width="172"
        height="15"
        rx="7.5"
        transform="translate(4757 159)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1488"
        data-name="Rectangle 1488"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 259)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1489"
        data-name="Rectangle 1489"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 296)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1490"
        data-name="Rectangle 1490"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 415)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1492"
        data-name="Rectangle 1492"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 566)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1493"
        data-name="Rectangle 1493"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 597)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1494"
        data-name="Rectangle 1494"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 628)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1495"
        data-name="Rectangle 1495"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 659)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1497"
        data-name="Rectangle 1497"
        width="69"
        height="15"
        rx="7.5"
        transform="translate(4757 803)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1498"
        data-name="Rectangle 1498"
        width="69"
        height="15"
        rx="7.5"
        transform="translate(4757 834)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1496"
        data-name="Rectangle 1496"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 770)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1499"
        data-name="Rectangle 1499"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 865)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1491"
        data-name="Rectangle 1491"
        width="124"
        height="15"
        rx="7.5"
        transform="translate(4757 447)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1486"
        data-name="Rectangle 1486"
        width="325"
        height="15"
        rx="7.5"
        transform="translate(4757 198)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1487"
        data-name="Rectangle 1487"
        width="259"
        height="15"
        rx="7.5"
        transform="translate(4757 222)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1554"
        data-name="Rectangle 1554"
        width="191"
        height="15"
        rx="7.5"
        transform="translate(4596 86)"
        fill="#f0f0f0"
      />
      <g
        id="Group_2650"
        data-name="Group 2650"
        transform="translate(4540 77.7)"
      >
        <g id="Group_742" data-name="Group 742" transform="translate(0 0.5)">
          <circle
            id="Ellipse_263"
            data-name="Ellipse 263"
            cx="16.5"
            cy="16.5"
            r="16.5"
            transform="translate(0 -0.2)"
            fill="#f0f0f0"
          />
        </g>
      </g>
      <g id="Group_2652" data-name="Group 2652">
        <path
          id="Icon_feather-chevron-right"
          data-name="Icon feather-chevron-right"
          d="M13.5,16.894l3.947-3.947L13.5,9"
          transform="translate(4671.816 32.478)"
          fill="none"
          stroke="#b8bbc3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <rect
          id="Rectangle_1555"
          data-name="Rectangle 1555"
          width="113"
          height="15"
          rx="7.5"
          transform="translate(4560 39)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1556"
          data-name="Rectangle 1556"
          width="142"
          height="15"
          rx="7.5"
          transform="translate(4721 39)"
          fill="#f0f0f0"
        />
        <circle
          id="Ellipse_286"
          data-name="Ellipse 286"
          cx="7.5"
          cy="7.5"
          r="7.5"
          transform="translate(4702 39)"
          fill="#f0f0f0"
        />
        <circle
          id="Ellipse_287"
          data-name="Ellipse 287"
          cx="7.5"
          cy="7.5"
          r="7.5"
          transform="translate(4541 39)"
          fill="#f0f0f0"
        />
      </g>
    </g>
  </svg>
);

export const termDetailTopBS = (
  <svg width="100%" height="100%" viewBox="0 0 1792 196.231">
    <g
      id="Group_2646"
      data-name="Group 2646"
      transform="translate(-82 -137.769)"
    >
      <g id="Group_2645" data-name="Group 2645">
        <path
          id="Path_2644"
          data-name="Path 2644"
          d="M0,0H1792V60H0Z"
          transform="translate(82 274)"
          fill="#f3f3f3"
          opacity="0.7"
        />
        <text
          id="Overview"
          transform="translate(95 313)"
          fill="#428bca"
          fontSize="14"
          fontFamily="OpenSansSemibold, OpenSans"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Overview
          </tspan>
        </text>
        <text
          id="Activity"
          transform="translate(237 313)"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
        >
          <tspan x="0" y="0">
            Activity
          </tspan>
        </text>
        <text
          id="Discussions"
          transform="translate(356 313)"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
        >
          <tspan x="0" y="0">
            Discussions
          </tspan>
        </text>
        <rect
          id="Rectangle_1174"
          data-name="Rectangle 1174"
          width="117"
          height="4"
          transform="translate(82 329)"
          fill="#428bca"
        />
        <g
          id="Group_1327"
          data-name="Group 1327"
          transform="translate(129.467 138.067)"
        >
          <path
            id="Path_2639"
            data-name="Path 2639"
            d="M0-2H88.2V38H0Z"
            transform="translate(1643.533 147.933)"
            fill="#4894ca"
          />
          <g
            id="Group_1326"
            data-name="Group 1326"
            transform="translate(3.533)"
          >
            <g
              id="Group_1321"
              data-name="Group 1321"
              transform="translate(1679 154)"
            >
              <text
                id="Edit"
                transform="translate(0 19)"
                fill="#fff"
                fontSize="18"
                fontFamily="OpenSansSemibold, OpenSans"
                fontWeight="600"
                letterSpacing="-0.01em"
              >
                <tspan x="0" y="0">
                  Edit
                </tspan>
              </text>
            </g>
            <g
              id="Group_1325"
              data-name="Group 1325"
              transform="translate(314 -760.719)"
            >
              <g
                id="Group_846"
                data-name="Group 846"
                transform="translate(1342 918.954)"
              >
                <g
                  id="Group_845"
                  data-name="Group 845"
                  transform="translate(0 0)"
                >
                  <path
                    id="Path_2270"
                    data-name="Path 2270"
                    d="M896.283-65.037v-.106q0-2.027,0-4.053a.221.221,0,0,1,.074-.171q4.193-4.19,8.384-8.381l.056-.054,4.259,4.263s-.025.028-.047.05q-4.2,4.2-8.4,8.395a.205.205,0,0,1-.128.061q-2.062,0-4.125,0C896.336-65.032,896.316-65.035,896.283-65.037Zm4.644-2.227-2.411-2.408c-.291.291-.59.589-.885.889a.15.15,0,0,0-.032.1c0,.32,0,.639,0,.959a.748.748,0,0,0,.009.078h1.306v1.295c.012.006.018.01.023.01.344,0,.687,0,1.03,0a.11.11,0,0,0,.07-.03C900.333-66.671,900.631-66.969,900.926-67.264Zm-1.361-2.791a.269.269,0,0,0,.208-.1l5.483-5.484a.557.557,0,0,0,.065-.074.256.256,0,0,0-.016-.307.258.258,0,0,0-.308-.009.635.635,0,0,0-.073.066l-5.472,5.47a.505.505,0,0,0-.08.1A.22.22,0,0,0,899.565-70.055Z"
                    transform="translate(-896.281 80.563)"
                    fill="#fff"
                  />
                  <path
                    id="Path_2271"
                    data-name="Path 2271"
                    d="M1413.119-225.329l-4.26-4.26c.017-.019.035-.041.056-.061q.836-.832,1.672-1.662a1.288,1.288,0,0,1,1.8.019c.571.562,1.136,1.129,1.7,1.694.229.228.454.459.687.683a1.339,1.339,0,0,1,0,1.93c-.545.52-1.068,1.062-1.6,1.6Z"
                    transform="translate(-1399.664 231.671)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      <g id="header">
        <g
          id="Group_1332"
          data-name="Group 1332"
          transform="translate(3026.168 -1004.464)"
        >
          <rect
            id="Rectangle_1162"
            data-name="Rectangle 1162"
            width="18.782"
            height="2.012"
            transform="translate(-1248.211 1147.865)"
            fill="#4c4c4c"
          />
          <rect
            id="Rectangle_1163"
            data-name="Rectangle 1163"
            width="18.782"
            height="2.012"
            transform="translate(-1248.211 1155.448)"
            fill="#4c4c4c"
          />
          <rect
            id="Rectangle_1164"
            data-name="Rectangle 1164"
            width="18.782"
            height="2.012"
            transform="translate(-1248.211 1163.03)"
            fill="#4c4c4c"
          />
          <rect
            id="Rectangle_1165"
            data-name="Rectangle 1165"
            width="2.233"
            height="2.012"
            transform="translate(-1253.168 1163.03)"
            fill="#4c4c4c"
          />
          <rect
            id="Rectangle_1166"
            data-name="Rectangle 1166"
            width="2.233"
            height="2.012"
            transform="translate(-1253.168 1155.448)"
            fill="#4c4c4c"
          />
          <rect
            id="Rectangle_1167"
            data-name="Rectangle 1167"
            width="2.233"
            height="2.012"
            transform="translate(-1253.168 1147.865)"
            fill="#4c4c4c"
          />
        </g>
        <text
          id="Save"
          transform="translate(1767 185)"
          fill="#4c4c4c"
          fontSize="16"
          fontFamily="OpenSans, OpenSans"
        >
          <tspan x="0" y="0">
            Save
          </tspan>
        </text>
        <text
          id="More"
          transform="translate(1834 185)"
          fill="#4c4c4c"
          fontSize="16"
          fontFamily="OpenSans, OpenSans"
        >
          <tspan x="0" y="0">
            More
          </tspan>
        </text>
        <text
          id="Follow"
          transform="translate(1690 185)"
          fill="#4c4c4c"
          fontSize="16"
          fontFamily="OpenSans, OpenSans"
        >
          <tspan x="0" y="0">
            Follow
          </tspan>
        </text>
        <g
          id="Group_1058"
          data-name="Group 1058"
          transform="translate(-134.064 -495.71)"
        >
          <g
            id="_7351082_eye_view_see_look_icon"
            data-name="7351082_eye_view_see_look_icon"
            transform="translate(1833.064 637.8)"
          >
            <path
              id="Path_2365"
              data-name="Path 2365"
              d="M17.895,7C10.75,7,5.937,13.219,4.408,15.508a1.486,1.486,0,0,0,0,1.664c1.529,2.288,6.342,8.508,13.487,8.508s11.958-6.219,13.487-8.508a1.486,1.486,0,0,0,0-1.664C29.852,13.219,25.04,7,17.895,7Z"
              transform="translate(-4.153 -7)"
              fill="none"
              stroke="#4c4c4c"
              strokeWidth="2"
            />
            <path
              id="Path_2366"
              data-name="Path 2366"
              d="M18.673,14.336A4.672,4.672,0,1,1,14,9.667,4.67,4.67,0,0,1,18.673,14.336Z"
              transform="translate(-0.261 -4.997)"
              fill="rgba(0,0,0,0)"
              stroke="#4c4c4c"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_1344" data-name="Group 1344" transform="translate(148 -1)">
          <circle
            id="Ellipse_265"
            data-name="Ellipse 265"
            cx="2.5"
            cy="2.5"
            r="2.5"
            transform="translate(1703 142)"
            fill="#4c4c4c"
          />
          <circle
            id="Ellipse_266"
            data-name="Ellipse 266"
            cx="2.5"
            cy="2.5"
            r="2.5"
            transform="translate(1703 150)"
            fill="#4c4c4c"
          />
          <circle
            id="Ellipse_267"
            data-name="Ellipse 267"
            cx="2.5"
            cy="2.5"
            r="2.5"
            transform="translate(1703 158)"
            fill="#4c4c4c"
          />
        </g>
        <rect
          id="Rectangle_1449"
          data-name="Rectangle 1449"
          width="254"
          height="20"
          rx="10"
          transform="translate(139 191)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1451"
          data-name="Rectangle 1451"
          width="177"
          height="15"
          rx="7.5"
          transform="translate(97 145)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1450"
          data-name="Rectangle 1450"
          width="510"
          height="15"
          rx="7.5"
          transform="translate(96 231)"
          fill="#f0f0f0"
        />
        <g id="Group_2127" data-name="Group 2127">
          <g id="Group_1348" data-name="Group 1348" transform="translate(-3)">
            <g
              id="Group_1335"
              data-name="Group 1335"
              transform="translate(177.241 -94.112)"
            >
              <path
                id="Path_2643"
                data-name="Path 2643"
                d="M-704.092,383.4c-1.943,0-3.886.013-5.829-.013a3.022,3.022,0,0,1-.973-.277,4.192,4.192,0,0,1-.576-.33.9.9,0,0,0-.178-.085c-.249-.076-.331-.021-.321.236a1.216,1.216,0,0,1-.514,1.1,1.326,1.326,0,0,1-.821.205q-3.544.007-7.089,0a1.2,1.2,0,0,1-1.228-.81.954.954,0,0,1-.07-.33q-.005-5.658,0-11.316a1.223,1.223,0,0,1,1.142-1.211c1.247-.018,2.494-.015,3.742-.017q2.177,0,4.354,0a1.352,1.352,0,0,1,.733.125c.135.081.244-.026.33-.113a4.662,4.662,0,0,0,.516-.573c.51-.729,1.018-1.461,1.5-2.21.384-.6.738-1.216,1.087-1.836.269-.479.513-.972.76-1.463a.506.506,0,0,0,.029-.228q-.017-.863-.04-1.725c-.012-.473-.031-.946-.04-1.419a1.538,1.538,0,0,1,.914-1.447,2.921,2.921,0,0,1,2.059-.268,2,2,0,0,1,1.337.769,3.9,3.9,0,0,1,.288.576,16.016,16.016,0,0,1,1.055,3,4.867,4.867,0,0,1,.048,1.973c-.122.657-.205,1.322-.311,1.982-.045.283-.1.565-.159.845-.021.1.012.134.1.135h.162q3.067,0,6.135,0a2.6,2.6,0,0,1,1.2.248,2.1,2.1,0,0,1,1.1,1.43,2.672,2.672,0,0,1-.618,2.47.249.249,0,0,0-.037.291,2.547,2.547,0,0,1-.113,2.249c-.115.222-.274.42-.4.637a.312.312,0,0,0-.032.239,2.551,2.551,0,0,1-.07,2.171c-.125.269-.309.509-.461.766a.215.215,0,0,0-.029.158,3.067,3.067,0,0,1-.014,2.178,2.7,2.7,0,0,1-2.23,1.773,7.075,7.075,0,0,1-1.23.1c-1.739.011-3.478,0-5.217,0Zm.338-13.544a1.17,1.17,0,0,1,.006-.127c.1-.571.213-1.14.311-1.712.147-.855.292-1.711.425-2.568a3.19,3.19,0,0,0,.051-.821,7.771,7.771,0,0,0-.231-1.159,14.98,14.98,0,0,0-1.045-2.65.232.232,0,0,0-.122-.117,6.1,6.1,0,0,0-.8-.2,1.538,1.538,0,0,0-1.06.263.389.389,0,0,0-.194.372q.037,1.637.048,3.274a1.135,1.135,0,0,1-.106.517c-.467.889-.922,1.787-1.442,2.645-.6.991-1.261,1.947-1.906,2.911a4.055,4.055,0,0,1-1.122,1.175c-.41.27-.808.558-1.225.816a.348.348,0,0,0-.181.348q.005,4.121,0,8.241c0,.042,0,.084,0,.126-.01.11.039.156.147.144a1.764,1.764,0,0,1,1.249.4,2.732,2.732,0,0,0,1.682.5c3.5-.02,6.994-.01,10.491-.011.144,0,.288,0,.432-.01a1.851,1.851,0,0,0,1.806-1.465,1.122,1.122,0,0,0-.709-1.28c-.054-.016-.133-.078-.133-.119a.179.179,0,0,1,.149-.206,1.754,1.754,0,0,0,1.26-1.1,1.207,1.207,0,0,0-.731-1.714.237.237,0,0,1-.13-.149.151.151,0,0,1,.137-.193,1.027,1.027,0,0,0,.224-.059,1.767,1.767,0,0,0,1.114-1.227,1.522,1.522,0,0,0,0-.723,1.113,1.113,0,0,0-.8-.776c-.153-.053-.187-.151-.126-.27a.328.328,0,0,1,.2-.119,1.808,1.808,0,0,0,1.309-1.891,1.1,1.1,0,0,0-.542-.9,1.48,1.48,0,0,0-.794-.184h-7.652Zm-9.622,7.546c0-1.823,0-3.646,0-5.469,0-.169-.041-.226-.218-.226q-3.355.008-6.71,0c-.179,0-.222.062-.222.229q.005,5.451,0,10.9c0,.179.05.236.234.236q3.337-.009,6.674,0c.238,0,.238,0,.238-.236Z"
                transform="translate(2140.452 -127.242)"
                fill="#4c4c4c"
                stroke="#4c4c4c"
                strokeWidth="0.4"
              />
            </g>
            <text
              id="Endorsed"
              transform="translate(1588 185)"
              fill="#4c4c4c"
              fontSize="16"
              fontFamily="OpenSans, OpenSans"
            >
              <tspan x="0" y="0">
                Endorsed
              </tspan>
            </text>
          </g>
          <rect
            id="Rectangle_1448"
            data-name="Rectangle 1448"
            width="24"
            height="15"
            rx="7.5"
            transform="translate(1627 144)"
            fill="#f0f0f0"
          />
        </g>
        <circle
          id="Ellipse_268"
          data-name="Ellipse 268"
          cx="12.5"
          cy="12.5"
          r="12.5"
          transform="translate(100 187)"
          fill="#f0f0f0"
        />
      </g>
    </g>
  </svg>
);

export const termDetailOverviewBS = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1775.5 1121"
    style={{ padding: "0 16px" }}
  >
    <g id="Group_2647" data-name="Group 2647" transform="translate(-95 -373)">
      <text
        id="Usability_Score:"
        data-name="Usability Score:"
        transform="translate(96 459)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Usability Score:
        </tspan>
      </text>
      <text
        id="Categories:"
        transform="translate(96 856)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Categories:
        </tspan>
      </text>
      <text
        id="Pattern:"
        transform="translate(96 903)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Pattern:
        </tspan>
      </text>
      <text
        id="Manual:"
        transform="translate(96 950)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Manual:
        </tspan>
      </text>
      <text
        id="Description"
        transform="translate(95 397)"
        fill="#328db5"
        fontSize="19"
        fontFamily="OpenSansSemibold, OpenSans"
        fontWeight="600"
      >
        <tspan x="0" y="0">
          Description
        </tspan>
      </text>
      <text
        id="Managed_By"
        data-name="Managed By"
        transform="translate(1065 397)"
        fill="#328db5"
        fontSize="19"
        fontFamily="OpenSansSemibold, OpenSans"
        fontWeight="600"
      >
        <tspan x="0" y="0">
          Managed By
        </tspan>
      </text>
      <line
        id="Line_187"
        data-name="Line 187"
        x2="805"
        transform="translate(95.5 417)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <line
        id="Line_351"
        data-name="Line 351"
        x2="805"
        transform="translate(1065 417)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <text
        id="Previously_known_as:"
        data-name="Previously known as:"
        transform="translate(96 637.355)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Previously known as:
        </tspan>
      </text>
      <text
        id="Replaces:"
        transform="translate(96 679.355)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Replaces:
        </tspan>
      </text>
      <g id="Group_1857" data-name="Group 1857" transform="translate(0 33)">
        <text
          id="Term_Type:_"
          data-name="Term Type: "
          transform="translate(96 567.355)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Term Type:{" "}
          </tspan>
        </text>
      </g>
      <text
        id="Definition:_"
        data-name="Definition: "
        transform="translate(96 497)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
        letterSpacing="-0.005em"
      >
        <tspan x="0" y="0">
          Definition:{" "}
        </tspan>
      </text>
      <text
        id="Business_Rules"
        data-name="Business Rules"
        transform="translate(95 794)"
        fill="#328db5"
        fontSize="19"
        fontFamily="OpenSansSemibold, OpenSans"
        fontWeight="600"
      >
        <tspan x="0" y="0">
          Business Rules
        </tspan>
      </text>
      <line
        id="Line_352"
        data-name="Line 352"
        x2="1775"
        transform="translate(95.5 814)"
        fill="none"
        stroke="#707070"
        strokeWidth="1"
        opacity="0.1"
      />
      <g
        id="Group_2221"
        data-name="Group 2221"
        transform="translate(-1378 487)"
      >
        <path
          id="Path_2645"
          data-name="Path 2645"
          d="M3.837,0H79.092c2.119,0,3.837,1.343,3.837,3V19c0,1.657-1.718,3-3.837,3H3.837C1.718,22,0,20.657,0,19V3C0,1.343,1.718,0,3.837,0Z"
          transform="translate(1681 352)"
          fill="#f0f0f0"
        />
      </g>
      <g
        id="Group_2218"
        data-name="Group 2218"
        transform="translate(-1378 534)"
      >
        <path
          id="Path_2645-2"
          data-name="Path 2645"
          d="M3.662,0H87.889c2.022,0,3.662,1.343,3.662,3V19c0,1.657-1.64,3-3.662,3H3.662C1.64,22,0,20.657,0,19V3C0,1.343,1.64,0,3.662,0Z"
          transform="translate(1681 352)"
          fill="#f0f0f0"
        />
      </g>
      <g
        id="Group_2219"
        data-name="Group 2219"
        transform="translate(-1282 534)"
      >
        <path
          id="Path_2645-3"
          data-name="Path 2645"
          d="M3,0H28a3,3,0,0,1,3,3V19a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
          transform="translate(1681 352)"
          fill="#f0f0f0"
        />
      </g>
      <g id="Group_2220" data-name="Group 2220" transform="translate(0 3)">
        <text
          id="Represents_Linked_Columns_"
          data-name="Represents (Linked Columns)"
          transform="translate(95 1086.851)"
          fill="#328db5"
          fontSize="19"
          fontFamily="OpenSansSemibold, OpenSans"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Represents (Linked Columns)
          </tspan>
        </text>
        <text
          id="Additional_Info"
          data-name="Additional Info"
          transform="translate(95 1331.62)"
          fill="#328db5"
          fontSize="19"
          fontFamily="OpenSansSemibold, OpenSans"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Additional Info
          </tspan>
        </text>
        <line
          id="Line_354"
          data-name="Line 354"
          x2="805"
          transform="translate(95.5 1106.851)"
          fill="none"
          stroke="#707070"
          strokeWidth="1"
          opacity="0.1"
        />
        <line
          id="Line_370"
          data-name="Line 370"
          x2="1775"
          transform="translate(95.5 1351.62)"
          fill="none"
          stroke="#707070"
          strokeWidth="1"
          opacity="0.1"
        />
        <g
          id="Group_1696"
          data-name="Group 1696"
          transform="translate(-83 -212.149)"
        >
          <text
            id="Classificaton"
            transform="translate(1148 1299)"
            fill="#328db5"
            fontSize="19"
            fontFamily="OpenSansSemibold, OpenSans"
            fontWeight="600"
          >
            <tspan x="0" y="0">
              Attributes
            </tspan>
          </text>
          <line
            id="Line_355"
            data-name="Line 355"
            x2="805"
            transform="translate(1148.5 1319)"
            fill="none"
            stroke="#707070"
            strokeWidth="1"
            opacity="0.1"
          />
        </g>
        <text
          id="PII_Classification:_"
          data-name="PII Classification: "
          transform="translate(1065 1149)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            PII Classification:{" "}
          </tspan>
        </text>
        <text
          id="Sensitivity:"
          transform="translate(1065 1181)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Sensitivity:
          </tspan>
        </text>
        <text
          id="Tags:"
          transform="translate(1065 1216)"
          fill="#4c4c4c"
          fontSize="14"
          fontFamily="OpenSans, OpenSans"
          letterSpacing="-0.005em"
        >
          <tspan x="0" y="0">
            Tags:
          </tspan>
        </text>
        <g id="Group_1873" data-name="Group 1873" transform="translate(0 -550)">
          <g
            id="Group_1872"
            data-name="Group 1872"
            transform="translate(0 -96)"
          >
            <rect
              id="Rectangle_1340"
              data-name="Rectangle 1340"
              width="56"
              height="26"
              rx="3"
              transform="translate(1253 1847)"
              fill="#f0f0f0"
            />
          </g>
        </g>
        <rect
          id="Rectangle_1402"
          data-name="Rectangle 1402"
          width="1151"
          height="34"
          rx="6"
          transform="translate(98 1405)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1403"
          data-name="Rectangle 1403"
          width="1151"
          height="34"
          rx="6"
          transform="translate(98 1457)"
          fill="#f0f0f0"
        />
        <circle
          id="Ellipse_285"
          data-name="Ellipse 285"
          cx="10.5"
          cy="10.5"
          r="10.5"
          transform="translate(862 1070)"
          fill="#f0f0f0"
        />
      </g>
      <g
        id="Group_2197"
        data-name="Group 2197"
        transform="translate(-1291 487)"
      >
        <path
          id="Path_2645-4"
          data-name="Path 2645"
          d="M3,0H28a3,3,0,0,1,3,3V19a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z"
          transform="translate(1681 352)"
          fill="#f0f0f0"
        />
      </g>
      <text
        id="Data_Steward"
        data-name="Data Steward"
        transform="translate(1065 459)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Data Steward
        </tspan>
      </text>
      <text
        id="System_SME"
        data-name="System SME"
        transform="translate(1065 503.408)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          System SME
        </tspan>
      </text>
      <text
        id="Audit_Trail:"
        data-name="Audit Trail:"
        transform="translate(1065 547.816)"
        fill="#4c4c4c"
        fontSize="14"
        fontFamily="OpenSans, OpenSans"
      >
        <tspan x="0" y="0">
          Audit Trail:
        </tspan>
      </text>
      <g id="Group_2641" data-name="Group 2641">
        <rect
          id="Rectangle_1536"
          data-name="Rectangle 1536"
          width="90"
          height="15"
          rx="7.5"
          transform="translate(303 445)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1540"
          data-name="Rectangle 1540"
          width="171"
          height="15"
          rx="7.5"
          transform="translate(303 586)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1541"
          data-name="Rectangle 1541"
          width="171"
          height="15"
          rx="7.5"
          transform="translate(303 623)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1542"
          data-name="Rectangle 1542"
          width="171"
          height="15"
          rx="7.5"
          transform="translate(303 669)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1537"
          data-name="Rectangle 1537"
          width="559"
          height="15"
          rx="7.5"
          transform="translate(303 487)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1538"
          data-name="Rectangle 1538"
          width="559"
          height="15"
          rx="7.5"
          transform="translate(303 513)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1539"
          data-name="Rectangle 1539"
          width="559"
          height="15"
          rx="7.5"
          transform="translate(303 539)"
          fill="#f0f0f0"
        />
      </g>
      <g id="Group_2642" data-name="Group 2642" transform="translate(-40)">
        <rect
          id="Rectangle_1394"
          data-name="Rectangle 1394"
          width="134"
          height="15"
          rx="7.5"
          transform="translate(1293 445)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1543"
          data-name="Rectangle 1543"
          width="134"
          height="15"
          rx="7.5"
          transform="translate(1293 490)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1544"
          data-name="Rectangle 1544"
          width="368"
          height="15"
          rx="7.5"
          transform="translate(1293 534)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1545"
          data-name="Rectangle 1545"
          width="368"
          height="15"
          rx="7.5"
          transform="translate(1293 565)"
          fill="#f0f0f0"
        />
      </g>
      <g id="Group_2643" data-name="Group 2643" transform="translate(-40)">
        <rect
          id="Rectangle_1546"
          data-name="Rectangle 1546"
          width="559"
          height="15"
          rx="7.5"
          transform="translate(343 935)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1547"
          data-name="Rectangle 1547"
          width="413"
          height="15"
          rx="7.5"
          transform="translate(343 961)"
          fill="#f0f0f0"
        />
      </g>
      <g id="Group_2644" data-name="Group 2644" transform="translate(1)">
        <rect
          id="Rectangle_1548"
          data-name="Rectangle 1548"
          width="415"
          height="15"
          rx="7.5"
          transform="translate(95 1136)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1549"
          data-name="Rectangle 1549"
          width="415"
          height="15"
          rx="7.5"
          transform="translate(95 1166)"
          fill="#f0f0f0"
        />
        <rect
          id="Rectangle_1550"
          data-name="Rectangle 1550"
          width="415"
          height="15"
          rx="7.5"
          transform="translate(95 1196)"
          fill="#f0f0f0"
        />
      </g>
      <rect
        id="Rectangle_1551"
        data-name="Rectangle 1551"
        width="90"
        height="15"
        rx="7.5"
        transform="translate(1253 1140)"
        fill="#f0f0f0"
      />
      <rect
        id="Rectangle_1552"
        data-name="Rectangle 1552"
        width="90"
        height="15"
        rx="7.5"
        transform="translate(1253 1172)"
        fill="#f0f0f0"
      />
    </g>
  </svg>
);
